/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnnotationUnread = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20.785 8.939a5.037 5.037 0 0 1-2.096-.113c.242.792.346 1.623.3 2.459a7.197 7.197 0 0 1-2.131 4.719l-3.64 3.546a1.562 1.562 0 0 1-1.174.448L12 19.996l-.044.002a1.567 1.567 0 0 1-1.175-.448l-3.639-3.546a7.197 7.197 0 0 1-2.132-4.72 7.153 7.153 0 0 1 1.6-4.894 7.119 7.119 0 0 1 2.415-1.76 7.312 7.312 0 0 1 6.018.031 5.04 5.04 0 0 1 .165-2.093 9.323 9.323 0 0 0-6.997.236A9.118 9.118 0 0 0 5.1 5.078l-.015.016-.013.016a9.154 9.154 0 0 0-2.06 6.283 9.197 9.197 0 0 0 2.724 6.034l3.648 3.555A3.566 3.566 0 0 0 12 21.998a3.566 3.566 0 0 0 2.615-1.016l3.642-3.549.006-.006a9.197 9.197 0 0 0 2.724-6.034 9.09 9.09 0 0 0-.202-2.454z" />
        <path d="M20 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      </g>
    </g>
  </Icon>
);
export { SvgAnnotationUnread as AnnotationUnread };
